/**
 * SectionCard — shared wrapper for Personal Details form sections.
 *
 * Mirrors Flutter `FormView` (`form_view_widget.dart`): header label + bordered
 * card body. Showcase look (header 16/600, hairline card, no side margin) comes from
 * the "patients (helper)" block in the bridge, keyed on the DS card's hooks. Visually consistent across Identity /
 * Demographics / Education / Occupation / Guardian.
 *
 * Composes the DS `CardWithTitle` atom — its own doc comment names this
 * exact use case ("form-section grouping (Personal Details, Insurance,
 * Emergency Contact, etc.)"). The DS `Card`/`CardHeader`/`CardTitle` family
 * was NOT used here: `Card`'s sizes are fixed width+height per variant
 * (DS-003 capture rule, "spec-mandated, not a tokenization gap" — xs
 * 240×120 up to xl 480×640px, no auto-height option), which cannot express
 * a form section of unbounded, content-driven height. `CardWithTitle` has
 * no such lock.
 */

import type { ReactNode } from 'react';
import { CardWithTitle } from '@scripsteam/scrips-signal-ds';

export interface SectionCardProps {
  header: string;
  children: ReactNode;
  /** Optional right-aligned slot for header actions (e.g. add-row buttons). */
  headerActions?: ReactNode;
}

export function SectionCard({ header, children, headerActions }: SectionCardProps) {
  return (
    <CardWithTitle
      title={header}
      action={headerActions}
      className="my-4"
    >
      {children}
    </CardWithTitle>
  );
}
